module.exports = __webpack_public_path__ + "img/service1.c3977a52.png";